import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }
  
  const role = authService.user()?.role;
  router.navigate([role === 'ADMIN' ? '/dashboard/admin' : '/dashboard/student']);
  return false;
};